export const BULK_SPLITER = /\n|,|;/;

export const parseBulkItems = (value: string, splitter: RegExp = BULK_SPLITER): string[] =>
  value
    .split(splitter)
    .map(item => item.trim())
    .filter(Boolean);
